export default "__VITE_ASSET__DN10Ug9S__"